/**
 * Extracts a synthetic version hash using the main hashes defined in
 * the service worker for index.html, main.<hash>.js, main.<hash>.css
 * @param swContents Body of service worker
 */
export function extractSwVersionHash(swContents: string): string | undefined {
  const indexHtmlHash = swContents.match(/\["\/index\.html",\s*"(\w+)"\]/);
  // console.log("index html hash: ", indexHtmlHash);

  const mainJsHash = swContents.match(
    /\["\/static\/js\/main\.(\w+)\.js",\s*"(\w+)"\]/
  );
  // console.log("main js hash: ", mainJsHash);

  const mainCssHash = swContents.match(
    /\["\/static\/css\/main\.(\w+)\.css",\s*"(\w+)"\]/
  );
  // console.log("main css hash: ", mainCssHash);

  if (indexHtmlHash !== null && mainJsHash !== null && mainCssHash !== null) {
    return [
      indexHtmlHash[1],
      mainJsHash[1],
      mainJsHash[2],
      mainCssHash[1],
      mainCssHash[2]
    ].join("-");
  } else {
    console.error("Unable to extract current SW version");
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/components/UpdateManager/UpdateManager.utils.ts